import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BatchFilterService } from '../../shared/filter/batch-filter.service';
import { AppState } from '../../../store';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { selectBatchTableQuery } from '../../../store/batch-table/batch-table.state';
import { FilterAssist } from '../../../models/filter-assist';
import { debounceTime, filter, map, mergeMap, switchMap } from 'rxjs/operators';
import { batchTableAddAssist, batchTableRemoveAssist } from '../../../store/batch-table/batch-table.actions';
import { Store } from '@ngrx/store';
import { MatOption } from '@angular/material/core';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { IconComponent } from '../../shared/icon/icon.component';
import { AsyncPipe } from '@angular/common';
import { MatChipGrid, MatChipRow, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { MatFormField } from '@angular/material/form-field';
import { BatchQuery } from '../../../models/batch-query';

@Component({
    selector: 'app-batch-table-filter',
    templateUrl: './batch-table-filter.component.html',
    styleUrls: ['./batch-table-filter.component.scss'],
    imports: [ReactiveFormsModule, MatFormField, MatChipGrid, MatChipRow, MatChipRemove, IconComponent, MatInput, MatChipInput, MatAutocompleteTrigger, MatAutocomplete, MatOption, AsyncPipe]
})
export class BatchTableFilterComponent implements OnInit {

    @ViewChild('termsInput') termsInput: ElementRef<HTMLInputElement>;

    searchForm = new FormGroup({
        terms: new FormControl('')
    });

    constructor(private batchFilterService: BatchFilterService, private store: Store<AppState>) {
    }

    query$: Observable<BatchQuery> = this.store.select(selectBatchTableQuery);
    activeAssists$: Observable<FilterAssist[]> = this.query$.pipe(
        switchMap((query) => this.batchFilterService.activeAssists(query))
    );
    offeredAssists$: Observable<FilterAssist[]> = this.searchForm.valueChanges.pipe(
        debounceTime(200),
        map(form => form.terms),
        filter(terms => typeof terms === 'string'),
        mergeMap(terms => this.batchFilterService.autocompleteTerms(terms))
    );

    ngOnInit(): void {
    }

    onAssistSelection(assist: FilterAssist): void {
        this.store.dispatch(batchTableAddAssist({ id: assist.id, parameter: assist.parameter }));
        this.termsInput.nativeElement.value = '';
        this.searchForm.get('terms').setValue('');
    }

    onRemoveAssist(id: string): void {
        this.store.dispatch(batchTableRemoveAssist({ id }));
    }

}
